import http from "../utils/http-common";

class SefEnablrdCustomersDataService {
  async getAll() {
    const resp = await http.get("/sef_enabled_customers");
    resp.data.rows = resp.data.rows.map((r) => { return { ...r, name: r.name + ` (${r.rate})` } })
    return resp;
  }

  get(id) {
    return http.get(`/sef_enabled_customers/${id}`);
  }

  create(data) {
    return http.post("/sef_enabled_customers", data);
  }

  update(id, data) {
    return http.put(`/sef_enabled_customers/${id}`, data);
  }

  delete(id) {
    return http.delete(`/sef_enabled_customers/${id}`);
  }
}

export default new SefEnablrdCustomersDataService();